import script from "./IOSApi.vue?vue&type=script&setup=true&lang=js"
export * from "./IOSApi.vue?vue&type=script&setup=true&lang=js"

import "./IOSApi.vue?vue&type=style&index=0&id=45f6440c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f6440c"]])

export default __exports__